import { UpOutlined } from '@ant-design/icons';
import { BackTop } from 'antd';
import React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";

var FeedbackBackTop = function FeedbackBackTop(props) {
  var onBacktopClick = props.onBacktopClick;
  return /*#__PURE__*/_jsx(BackTop, {
    onClick: onBacktopClick,
    className: 'dr-feedback-backtop',
    children: /*#__PURE__*/_jsx("div", {
      children: /*#__PURE__*/_jsx(UpOutlined, {})
    })
  });
};

export default FeedbackBackTop;